<template>
  <el-dialog title="变动前" class="global-dialog" :visible="true" width="800px" @close="$emit('closeDlg')">
    <div class="dlg-content" v-loading="loading">
      <el-form label-width="120px" class="before-change-form">
        <el-row>
          <el-col :span="12" v-for="field in fields" :key="field.key">
            <el-form-item :label="field.label">
              <span class="before-change-value">{{ beforeChange[field.key] || '--' }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('closeDlg')">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DeliveryBeforeChangeDlg',
  props: {
    pickupId: { type: String, required: true },
    recordId: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      beforeChange: {},
      fields: [
        { key: 'vehicleKey', label: '车/船号' },
        { key: 'vehicleGph', label: '挂车号' },
        { key: 'driverName', label: '联系人' },
        { key: 'driverMobile', label: '手机号' },
        { key: 'driverKey', label: '身份证号' },
        { key: 'vehicleStartAddressName', label: '提货库点' },
        { key: 'modifyUser', label: '修改人' },
        { key: 'modifyTime', label: '修改时间' }
      ]
    }
  },
  created() {
    this.loading = true
    this.$axios.get(this.$apis.deliveryOrder.selectVehicleBeforeChange, {
      params: { relatedId: this.pickupId, recordId: this.recordId }
    }).then(res => {
      this.beforeChange = res
    }).catch(() => {
      this.$emit('closeDlg')
    }).finally(() => {
      this.loading = false
    })
  }
}
</script>

<style scoped>
.before-change-form { padding: 20px; }
.before-change-value { white-space: pre-wrap; overflow-wrap: anywhere; }
</style>
